import axios from "axios";
const baseURL: any = process.env.REACT_APP_API_URL;
export function sendWalletLockRegistration(data: any) {
  return axios
    .post(`${baseURL}/comandos/registrar/datos/bloqueo-cartera`, data)
    .catch((e) => console.error("sendWalletLookRegistration catch:", e));
}
